import "./style.css"

const Footer = () => {
    return (
        <footer>
            <p>© 2025 | Hover Systems LLC</p>
        </footer>

    );
}
 
export default Footer;